import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import { showCRMFailureToastWithGivenMessage } from '@flowwai-frontend/bps-officer-web/common/ui'
import { useSetSessionDetails } from '@flowwai-frontend/shared/auth/common'

import { SsoExchangeResponseType } from '../services/types'
import { getPath } from '../utils/StorageUtils'
import { convertSecondsToDays } from '../utils/timeUtils'
import { useSsoExchangeAPI } from './apis/useSsoExchangeAPI'
import { stripSsoCodeFromUrl } from '../utils/ssoUtils'

interface HookArgs {
   ssoCode: string
}

const useSsoLogin = (args: HookArgs): { status: APIStatus } => {
   const { ssoExchangeAPI, ssoExchangeAPIStatus } = useSsoExchangeAPI()
   const setSessionDetails = useSetSessionDetails()

   const history = useHistory()

   useEffect(() => {
      ssoExchangeAPI(
         { code: args.ssoCode },
         {
            onSuccess: data => {
               const {
                  access_token,
                  refresh_token,
                  expires_in_seconds
               } = data as SsoExchangeResponseType
               setSessionDetails({
                  accessToken: access_token,
                  refreshToken: refresh_token,
                  expiredInDays: convertSecondsToDays(expires_in_seconds)
               })
               history.push(getPath())
               stripSsoCodeFromUrl()
            },
            onError: () => {
               showCRMFailureToastWithGivenMessage('Failed to Sign-In')
               stripSsoCodeFromUrl()
            }
         }
      )
   }, [])

   return { status: ssoExchangeAPIStatus }
}

export default useSsoLogin
